import { FC } from 'react';

interface Props {
  title: string;
  subTitle: string;
}

export const Heading: FC<Props> = ({ title, subTitle }) => (
  <div>
    <p className="text-center font-outfit text-sm font-semibold tracking-[0.84px] text-gray">
      {subTitle}
    </p>
    <h1 className="text-center text-3xl text-black">{title}</h1>
  </div>
);
